import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import { DriveOnDisplayableTaskDto as DriveOnTask } from '@/generated/model';
import { AccordionDetails, Button, ButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDriveOnContext } from '@/contexts/DriveOnContext';

import './TaskChooser.css';

type OtherTaskChooserProps = {
  task: DriveOnTask;
  setTask: (task: DriveOnTask) => void;
  expanded: boolean | undefined;
  logbook: boolean;
  enableSelect: boolean;
};

export function AdhocTaskChooser({ task, setTask, expanded, logbook, enableSelect }: OtherTaskChooserProps) {
  const { t } = useTranslation();
  const driveonCtx = useDriveOnContext();

  function setExpandIcon() {
    if (!expanded) {
      return <ExpandMoreIcon />;
    }
  }

   function isTaskSelected() : boolean {
    if (driveonCtx.task?.eventusId === task.eventusId && !logbook) {
      return true;
    }
    return false;
  }

  function showSelectButton() {
    if (enableSelect) {
      return (
        <AccordionDetails
          sx={{
            backgroundColor: 'rgb(156, 153, 153)',
          }}
        >
          <ButtonGroup fullWidth>
            <Button
              onClick={() => setTask(task)}
              variant="contained"
              startIcon={<PlayArrowOutlinedIcon />}
              sx={{ color: 'white', backgroundColor: 'red !important' }}
            >
              {t('menetlevel.taskchooser.button.start')}
            </Button>
          </ButtonGroup>
        </AccordionDetails>
      );
    }
  }

  function showSelectedAccordion() {
    return (
      <>
        <Accordion 
          disableGutters={true} 
          expanded={false}
          elevation={0}
          sx={{ 
            boxShadow: 'none',
            '&:before': {
              display: 'none',
            },
            backgroundColor: 'rgb(161, 194, 171)',
            border: '3px solid rgb(15, 90, 38)',
            '&:first-of-type': {
              borderRadius: '8px 8px 0 0',
            },
            '&:last-of-type': {
              borderRadius: '0 0 8px 8px',
            },
          }} 
        >
          <AccordionSummary>
            <Typography component="div">
              <div>{task.taskName}</div>
            </Typography>
          </AccordionSummary>
        </Accordion>
      </>
      );
  }

  function showAccordion() {
    return (<Accordion 
        disableGutters={true} 
        expanded={expanded}
        elevation={0}
        sx={{ 
          boxShadow: 'none',
          '&:before': {
            display: 'none',
          },
          backgroundColor: 'rgb(199, 199, 199)',
          border: '2px solid rgb(44, 39, 39)',
          '&:first-of-type': {
            borderRadius: '8px 8px 0 0',
          },
          '&:last-of-type': {
            borderRadius: '0 0 8px 8px',
          },
        }} 
        >
        <AccordionSummary 
          expandIcon={setExpandIcon()}
        >
          <Typography component="div">
            <div>{task.taskName}</div>
          </Typography>
        </AccordionSummary>
        {showSelectButton()}
      </Accordion>);
  }

  return isTaskSelected() ? showSelectedAccordion() : showAccordion();
 
}
